import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { GatewayDTO } from '../../../../core/models/gateway';
import { AuthenticationService } from '../../../../core/services/authentication.service';
import { GatewayService } from '../../../../core/services/gateway.service';
import { AddGatewayComponent } from '../../modals/add-gateway/add-gateway.component';
import { DeleteGatewayComponent } from '../../modals/delete-gateway/delete-gateway.component';
import { UpdateGatewayComponent } from '../../modals/update-gateway/update-gateway.component';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, Subscription } from 'rxjs';
import { NavigationService } from '../../../../core/services/navigation.service';
import { Entities } from '../../../../core/models/globals';
import { ConfigEntityService } from '../../../../core/services/config-entity.service';
import { UserRoleNames } from 'src/app/core/models/users';

@Component({
  selector: 'app-gateway-list',
  templateUrl: './gateway-list.component.html',
  styleUrls: ['./gateway-list.component.scss']
})
export class GatewayListComponent implements OnInit {
  gateways: GatewayDTO[] = [];
  dataEmpty: boolean = false;
  currentLoggedUser: string;
  sortName = 0;
  sortIP = 0;
  sortPort = 0;
  p: number = 1;
  itemsPerPage: number = 15;
  filterText = new FormControl('');
  filteredGateways: GatewayDTO[] = [];
  universalSub: Subscription;
  currentEntity: string;
  loggedInUserRole: string = this.authenticationService.getRole() || "";
  isMonitor: boolean = this.loggedInUserRole == UserRoleNames.Reader;

  constructor(
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private gatewayService: GatewayService,
    private navService: NavigationService,
    private configEntityService: ConfigEntityService,
    private snackBar: MatSnackBar,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.navService.sendLeftPanelIndex(4);
    this.configEntityService.sendActiveEntity('Gateway');
    this.navService.sendChildData('Gateway');
    this.navService.sendParentData('');
    this.spinner.show();
    this.loadGatewayData();
    this.filterText.valueChanges
      .pipe(distinctUntilChanged(), debounceTime(300))
      .subscribe((value) => {
        this.filteredGateways = this.gateways.filter((gw) =>
          gw.name.toLowerCase().includes(value.toLowerCase()) || gw.ip.toLowerCase().includes(value.toLowerCase())
          || gw.port.toLowerCase().includes(value.toLowerCase())
        );
      });

      this.universalSub = this.navService.breadcrumbEntity.subscribe(x => {
        if (this.currentEntity != x) {
          this.currentEntity = x;
        }
      })

      if (this.currentEntity == Entities.Configurator) {
        this.navService.sendLeftPanelIndex(7);
        this.configEntityService.sendActiveEntity('Gateway')
        
      }
  }

  loadGatewayData() {
    this.gatewayService.getAllGateways()
      .subscribe({
        next: (data) => {
          this.gateways = <GatewayDTO[]>(data);
          this.filteredGateways = this.gateways;
          this.spinner.hide();
        },
        error: () => {

        },
        complete: () => {

        },
      });
  }

  gatewayAction(actionName: string, gw: GatewayDTO) {
    if (actionName == "Delete") {
      this.deleteGateway(gw);
    }
    else {
      this.editGateway(gw);
    }
  }

  deleteGateway(gw: GatewayDTO) {
    const dialogRef = this.dialog.open(DeleteGatewayComponent, {
      disableClose: true,
      autoFocus: false,
      width: '400px',
      data: { title: 'Delete Gateway', content: 'Do you want to delete the Gateway?' }
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.gatewayService.deleteGateway(gw)
          .subscribe({
            next: () => {

            },
            error: () => {

            },
            complete: () => {

            }
          });

        setTimeout(x => {
          this.loadGatewayData();
        }, 1000)
      }
    });
  }

  addGateway() {
    const dialogRef = this.dialog.open(AddGatewayComponent, {
      autoFocus: false,
      disableClose: true,
      width: '400px'
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.spinner.show();
        this.gatewayService.addGateway(res)
          .subscribe({
            next: (data: any) => {
              this.spinner.hide();
              this.loadGatewayData();
            },
            error: (err: any) => {
              this.snackBar.open(err.error.message || "Action cannot be completed.", "OK", { duration: 5000 });
              this.spinner.hide();
              this.loadGatewayData();
            }
          });
      }
    });
  }

  editGateway(oldGw: GatewayDTO) {
    const dialogRef = this.dialog.open(UpdateGatewayComponent, {
      autoFocus: false,
      disableClose: true,
      width: '400px',
      data: { olgGw: oldGw }
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.spinner.show();
        this.gatewayService.editGateway(oldGw.name, res)
          .subscribe({
            next: (data: any) => {
              this.spinner.hide();
              this.loadGatewayData();
            },
            error: (err: any) => {
              this.snackBar.open(err.error.message || "Action cannot be completed.", "OK", { duration: 5000 });
              this.spinner.hide();
              this.loadGatewayData();
            }
          });
      }
    });
  }

  sortByName() {
    if (this.sortName == 0) {
      this.gateways.sort((a, b) => 0 - (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));
    }
    if (this.sortName == 1) {
      this.gateways.sort((a, b) => 0 - (b.name.toLowerCase() > a.name.toLowerCase() ? 1 : -1));
    }
    this.sortName++
    if (this.sortName == 2) {
      this.sortName = 0;
    }
  }

  sortByIP() {
    if (this.sortIP == 0) {
      this.gateways.sort((a, b) => 0 - (a.ip.toLowerCase() > b.ip.toLowerCase() ? 1 : -1));
    }
    if (this.sortIP == 1) {
      this.gateways.sort((a, b) => 0 - (b.ip.toLowerCase() > a.ip.toLowerCase() ? 1 : -1));
    }
    this.sortIP++
    if (this.sortIP == 2) {
      this.sortIP = 0;
    }
  }

  sortByPort() {
    if (this.sortPort == 0) {
      this.gateways.sort((a, b) => 0 - (a.port.toLowerCase() > b.port.toLowerCase() ? 1 : -1));
    }
    if (this.sortPort == 1) {
      this.gateways.sort((a, b) => 0 - (b.port.toLowerCase() > a.port.toLowerCase() ? 1 : -1));
    }
    this.sortPort++
    if (this.sortPort == 2) {
      this.sortPort = 0;
    }
  }
}
